export const apartmentCategoryNavByLocale = {
  'en-us': [
    { uid: 'comfort', label: 'Comfort' },
    { uid: 'executive', label: 'Executive' },
  ],
  'fr-ca': [
    { uid: 'confort', label: 'Confort' },
    { uid: 'executif', label: 'Exécutif' },
    { uid: 'signature', label: 'Signature' },
  ],
}

export const footerApartmentsByLocale = {
  'en-us': [
    { slug: 'comfort', label: 'Comfort' },
    { slug: 'comfort-plus', label: 'Comfort +' },
    { slug: 'executive', label: 'Executive' },
    { slug: 'executive-plus', label: 'Executive +' },
    { slug: 'signature-plus', label: 'Signature +' },
  ],
  'fr-ca': [
    { slug: 'confort', label: 'Confort' },
    { slug: 'confort-plus', label: 'Confort +' },
    { slug: 'executive', label: 'Exécutif' },
    { slug: 'executive-plus', label: 'Exécutif +' },
    { slug: 'signature-plus', label: 'Signature +' },
  ],
}
